<template lang="pug">
  validation-observer(ref='observer' tag='form').form
    el-row
      divider.text-container(label="Cadastro de documentos")

    .container-cadastro
      el-row
        validation-provider(rules="required", v-slot="{ errors }", name="documento")
          app-label(label="Upload do documento:", :required="true")
          app-upload-area(
            id="documento"
            :target="urlUpload"
            :fileType="validExtensions"
            :onSuccess="onSuccess"
            @download="downloadDocumento"
            :documento="documento"
            v-model="documento"
            @removerDocumento="removerDocumento"
            :errors="errors"
            :onError="onError"
          )

      el-row(type='flex' :gutter='20')
        el-col(:span="8")
          validation-provider(rules="required", v-slot="{ errors }", name="Nome")
            app-label(label="Nome do documento:", :required="true")
            el-input.input(v-model="documentoAssinatura.nome", :class="{'erro' : errors.length}")
            span.help.erro {{ errors[0] }}

        el-col(:span="8")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Tipo do documento:", :required="true")
            el-select.input(
              filterable,
              :filter-method="filtrarTipoDocumento"
              class="select",
              v-model="documentoAssinatura.tipo",
              placeholder="Selecione",
              value-key="id",
              name="Tipo",
              :class="{'erro' : errors.length}",
              @paste.native="onPaste"
            )
              el-option(
                v-for="item in tiposDocumentoFiltrados",
                :key="item.id",
                :label="item.nome",
                :value="item"
              )
            span.help.erro {{ errors[0] }}

        el-col(:span="8")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Responsável(eis):", :required="true")
            el-select.input(
              filterable,
              :filter-method="filtrarResponsaveis",
              multiple,
              class="select",
              collapse-tags,
              v-model="documentoAssinatura.responsaveis",
              placeholder="Selecione",
              value-key="id",
              name="Resposavel",
              :class="{'erro' : errors.length}",
              @paste.native="onPaste"
            )
              el-option(
                v-for="item in responsaveisFiltrados",
                :key="item.id",
                :label="item.usuario.pessoa.nomeRazaoSocial",
                :value="item"
              )
            span.help.erro {{ errors[0] }}

    app-buttons-cadastro(
      :isPrimeiroPasso="true",
      :isUltimoPasso="true",
      @cancelar="cancelar",
      @finalizar="finalizar"
    )

</template>

<script>
import AppUploadArea from '@/components/AppUploadArea'
import FileHelper from '@/utils/fileHelper'
import Divider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import cloneDeep from 'lodash/cloneDeep'
import utils from '@/utils/utils'
import { mapActions } from 'vuex'

const DOCUMENTO_ASSINATURA_EMPTY = {
  nome: null,
  nomeOriginal: null,
  assinadores: [],
  responsaveis: [],
  tipo: null
}

export default {
  components: {
    AppUploadArea,
    FileHelper,
    Divider,
    AppLabel,
    AppButtonsCadastro
  },

  mixins: [AppNotificacao],

  data () {
    return {
      responsaveis: [],
      responsaveisFiltrados: [],
      tiposDocumento: [],
      tiposDocumentoFiltrados: [],
      documentoAssinatura: cloneDeep(DOCUMENTO_ASSINATURA_EMPTY),
      documento: null,
      validExtensions: ['pdf'],
      urlUpload: this.$rotas.PUBLICO.UPLOAD
    }
  },

  created () {
    try {
      this.getResponsaveis().then(response => {
        this.responsaveis = response
        this.responsaveisFiltrados = response
      })

      this.getTiposDocumento().then(response => {
        this.tiposDocumento = response.filter(tipoDoc => tipoDoc.id !== 18)
        this.tiposDocumentoFiltrados = response.filter(
          tipoDoc => tipoDoc.id !== 18
        )
      })

      const { id } = this.$route.query

      if (id) {
        this.findById(id).then(response => {
          if (response.jaAssinadoPorPeloMenosPorUmaPessoa) {
            this.goToListagem()
          }

          this.documento = cloneDeep(response)

          this.documentoAssinatura = response

          this.documentoAssinatura.responsaveis = this.documentoAssinatura.assinadores.map(
            assinador => assinador.responsavel
          )
        })
      }
    } catch (error) {
      this.showNotificacao(
        this.$messages.TIPO_ERROR,
        this.$messages.TITULO_ERROR,
        error.message
      )

      this.goToListagem()
    }
  },

  methods: {
    ...mapActions({
      getResponsaveis: 'responsavel/getResponsaveis',
      getTiposDocumento: 'tipoDocumentoAssinatura/getTiposDocumento',
      downloadDocumentos: 'documentoAssinatura/download',
      save: 'documentoAssinatura/save',
      findById: 'documentoAssinatura/findById'
    }),

    filtrarTipoDocumento (filterValue) {
      this.tiposDocumentoFiltrados = this.tiposDocumento.filter(item => {
        const normalize = text => {
          return text
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
        }
        return normalize(item.nome).indexOf(normalize(filterValue)) > -1
      })
    },

    onError () {
      if (this.documento != null) {
        this.documento = null
        this.documento = cloneDeep(this.documentoAssinatura)
      }
    },

    filtrarResponsaveis (filterValue) {
      this.responsaveisFiltrados = this.responsaveis.filter(item => {
        const normalize = text => {
          return text
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
        }
        return (
          normalize(item.usuario.pessoa.nomeRazaoSocial).indexOf(
            normalize(filterValue)
          ) > -1
        )
      })
    },

    onSuccess (id, resumableFile, fileKey) {
      const fileName = resumableFile.fileName

      this.documento = {
        fileKey: fileKey,
        nomeOriginal: fileName,
        tamanho: resumableFile.size
      }

      this.documentoAssinatura.nomeOriginal = fileName
      this.documentoAssinatura.nome = utils.getFileNameWithoutExtension(
        fileName
      )
      this.documentoAssinatura.fileKey = fileKey
    },

    removerDocumento () {
      this.documento = null
    },

    async downloadDocumento () {
      const documento = this.documentoAssinatura
      const arrayBuffer = await this.downloadDocumentos({
        fileKey: documento.fileKey,
        id: documento.id
      })
      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },

    async finalizar () {
      const valido = await this.$refs.observer.validate()

      if (valido) {
        this.confirmBox(
          'Deseja confirmar esta ação?',
          this.$messages.TITULO_WARNING,
          async () => {
            const assinadores = this.documentoAssinatura.assinadores

            this.documentoAssinatura.responsaveis.forEach(responsavel => {
              const assinador = assinadores.filter(
                a => a.responsavel.id === responsavel.id
              )

              if (assinador.length === 0) {
                assinadores.push({
                  responsavel
                })
              }
            })

            const idsResponsaveis = this.documentoAssinatura.responsaveis.map(
              responsavel => responsavel.id
            )
            const indexToRemove = []

            this.documentoAssinatura.assinadores.forEach((assinador, index) => {
              if (!idsResponsaveis.includes(assinador.responsavel.id)) {
                indexToRemove.push(index)
              }
            })

            indexToRemove.forEach(index => {
              this.documentoAssinatura.assinadores.splice(index, 1)
            })

            delete this.documentoAssinatura.responsaveis

            await this.save(this.documentoAssinatura)

            if (this.documentoAssinatura.id) {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.SUCESSO_ALTERAR_DOCUMENTO_ASSINATURA
              )
            } else {
              this.showNotificacao(
                this.$messages.TIPO_SUCCESS,
                this.$messages.TITULO_SUCCESS,
                this.$messages.SUCESSO_CADASTRAR_DOCUMENTO_ASSINATURA
              )
            }

            this.goToListagem()
          },
          () => {},
          'Sim',
          'Não'
        )
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.ERRO_VALIDACAO_FINALIZAR_CADASTRO
        )
      }
      if (this.responsaveisFiltrados.length === 0) {
        this.responsaveisFiltrados = this.responsaveis
      }
    },

    cancelar () {
      this.goToListagem()
    },

    goToListagem () {
      this.$router.push({
        name: 'assinatura/home'
      })
    },

    onPaste (evt) {
      evt.preventDefault()
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.container-cadastro {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 10px;
}

.text-container {
  padding-bottom: 50px;
}

.text-container >>> .label-divider {
  padding-top: 0px;
}

.container-input {
  margin-right: 20px;
}

.el-select {
  display: block;
}

>>> .el-select__tags-text {
  color: #4d5659;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/CadastroDocumento.vue